import { Route } from "@lifi/sdk";

export class AdvanceRoutesLiFi {
    items: Route[]
}